import React, { useState, useMemo } from 'react';

const LegendaAutomatica = ({ 
  groupRefs, 
  imageStates, 
  handleToggleLightGroup, 
  visibleGroups = [], // Adicionamos visibleGroups como prop
  sendCommand = null, // Adicionamos sendCommand como prop opcional
  className = "campo-clickable-element-pagina1"
}) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  // Otimização: Use useMemo para calcular esses valores apenas quando necessário
  const { validLightGroups, legendaItems } = useMemo(() => {
    // Conta quantos LightGroups válidos temos para calcular a altura
    const validRefs = Object.entries(groupRefs.current || {})
      .filter(([_, ref]) => ref && ref.current);
    
    const validCount = validRefs.length;
    
    // Extrai os dados dos componentes LightGroup para criar a legenda
    const items = validRefs.map(([groupId, ref], index, array) => {
      const props = ref.current.props;
      
      // Encontra o grupo correspondente na lista de grupos visíveis
      const group = visibleGroups.find(g => g.id === groupId) || {};
      
      // Usa o número do circuito do grupo se disponível, ou extrai do groupId
      const number = group.circleNumber || parseInt(groupId.replace(/\D/g, ''));
      
      const description = props.descricao;
      const imageState = imageStates[groupId];
      const isLast = index === array.length - 1;

      // Estilo para altura dinâmica quando expandido
      const itemStyle = expanded ? {
        height: `${100 / (validCount + 1)}%` // +1 para o botão "Acionamentos"
      } : {};

      return (
        <div
          key={groupId}
          id={`clickable-element-${groupId}`}
          className={isLast ? "clickable-element-last" : "clickable-element"}
          style={itemStyle}
          onClick={() => {
            handleToggleLightGroup(groupId, !imageState);
            
            // Usa sendCommand se fornecido, ou ref.current.sendCommand como fallback
            if (sendCommand && group) {
              const command = imageState ? 
                { modulo: group.modulo, idx: group.idx, status: "OFF" } : 
                { modulo: group.modulo, idx: group.idx, status: "ON" };
              sendCommand(description, command);
            } else if (ref.current) {
              ref.current.sendCommand(
                description,
                imageState ? ref.current.props.offCommand : ref.current.props.onCommand
              );
            }
          }}
        >
          <p className={`NumberTextBar${imageState ? 'Highlighted' : ''}`}>{number}</p>
          <p className="textBar">{description}</p>
        </div>
      );
    });
    
    return { validLightGroups: validCount, legendaItems: items };
  }, [groupRefs, imageStates, expanded, handleToggleLightGroup, visibleGroups, sendCommand]);

  // Estilo dinâmico do cabeçalho
  const headerStyle = expanded ? {
    height: `${100 / (validLightGroups + 1)}%` // Mesma altura que os itens
  } : {};

  return (
    <div className={className}>
      <div 
        className={`Topico-Menubar${expanded ? '-expanded' : ''}`}
        style={expanded ? { height: '100%' } : {}}
      >
        <p 
          className={`topicoParagrafoMenuBar${expanded ? '-expanded' : ''}`} 
          style={headerStyle}
          onClick={toggleExpand}
        >
          <b>Acionamentos</b>
        </p>
        
        {expanded && (
          <div className="legenda">
            {legendaItems}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(LegendaAutomatica); // Uso do React.memo para evitar re-renders desnecessários